"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircularList = void 0;
/**
 * Implements a list of items that wraps around so getting an item at a certain index
 * will wrap around
 */
class CircularList {
    constructor(list = []) {
        this.list = list;
        this.length = 0;
        this.length = this.list.length;
    }
    push(...items) {
        return this.length = this.list.push(...items);
    }
    indexOf(item) {
        return this.list.indexOf(item);
    }
    findIndex(predicate) {
        return this.list.findIndex(predicate);
    }
    itemAt(index) {
        index %= this.length;
        if (index < 0) {
            index = this.length + index;
        }
        return this.list[index];
    }
    /**
     * Gets the list as an array
     */
    getList() {
        return this.list.slice();
    }
}
exports.CircularList = CircularList;
//# sourceMappingURL=circular-list.js.map